function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { actions as ppcActions } from '../../reducers/ppc.reducer';
import PageData from './page/Page.context';
import PageBackButton from '../common/page/PageBackButton.react';
import PpcPageDetails from './ppc/PpcPageDetails.react';
import PpcPageBanner from '../common/ppc/PpcPageBanner.react';
import PpcBreadcrumbs from '../common/ppc/PpcBreadcrumbs.react';
import SEO from '../common/page-components/SEO.react';
var PpcPage = function PpcPage() {
  var _state$banner, _state$breadcrumbs;
  var _useParams = useParams(),
    pageID = _useParams.pageID;
  var dispatch = useDispatch();
  var page = useSelector(function (s) {
    return s.ppc.page.details;
  });
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    dispatch({
      type: ppcActions.page,
      payload: {
        formData: {
          pageID: pageID
        },
        route: 'details'
      }
    });
  }, [pageID]);
  useEffect(function () {
    if (page[pageID]) setState(page[pageID]);
  }, [pageID, page]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageData.Provider, {
    value: [state, setState]
  }, /*#__PURE__*/React.createElement(PageBackButton, null), /*#__PURE__*/React.createElement(PpcPageDetails, null), ((_state$banner = state.banner) === null || _state$banner === void 0 ? void 0 : _state$banner.isVisible) && /*#__PURE__*/React.createElement(PpcPageBanner, {
    id: state._id,
    banner: state.banner || {},
    bannerType: "page"
  }), ((_state$breadcrumbs = state.breadcrumbs) === null || _state$breadcrumbs === void 0 ? void 0 : _state$breadcrumbs.isVisible) && /*#__PURE__*/React.createElement(PpcBreadcrumbs, {
    id: state._id,
    banner: state.breadcrumbs || {},
    type: "page"
  }), /*#__PURE__*/React.createElement(SEO, {
    type: "ppcPage",
    itemID: pageID,
    metadata: state.metadata || {}
  })));
};
export default PpcPage;